import { ObjectsParams } from '../../types/ParamsTypes';

export const getUpdatedObjectFilterSortingParams = (
  objectsParams: ObjectsParams,
  value: string,
): ObjectsParams => {
  return { ...objectsParams, sorting: value };
};
